'use client';

import { PublicKey } from '@solana/web3.js';
import { useCallback } from 'react';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import useDriftAccountsStore from 'src/stores/useDriftAccountsStore';

/**
 * Hook for updating the current subaccount, including both store state and drift client.
 */
export const useUpdateCurrentSubaccount = () => {
	const driftClient = useDriftStore((s) => s.driftClient.client);
	const updateCurrentSubAccount = useDriftAccountsStore(
		(s) => s._updateCurrentSubAccount
	);

	const updateCurrentSubaccount = useCallback(
		(newSubaccountId: number, authority: PublicKey) => {
			// Update the store state
			updateCurrentSubAccount(newSubaccountId, authority);

			// Switch the active user in the drift client
			driftClient?.switchActiveUser(newSubaccountId, authority);
		},
		[driftClient, updateCurrentSubAccount]
	);

	return { updateCurrentSubaccount };
};
